import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.anchor-section-bar',
        sections: '.anchor-section-bar__sections',
        container: '.anchor-section-bar__container',
        wrapper: '.anchor-section-bar__wrapper',
        section: '.anchor-section',
        sectionLink: '.anchor-section-bar__section',
        arrowLeft: '.anchor-section-bar__arrow-left',
        arrowRight: '.anchor-section-bar__arrow-right'
    },
    dataAttributes: {
        sectionName: 'anchor-section-name',
        scrollToSectionName: 'anchor-scroll-to-section-name',
       anchorButtonLabel: 'anchor-button-label'
    },
    classNames: {
        arrowLeftVisible: 'anchor-section-bar__arrow-left--visible',
        arrowRightVisible: 'anchor-section-bar__arrow-right--visible',
        wrapperRight: 'anchor-section-bar__wrapper--right',
    },
};

class AnchorSectionBar {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._enabledArrows = false;
        this._lastWindowTop = 0;
        this._currentTranslateX = 0;
    }

    init() {
        this._elements = this._getDomElements();
        this._renderComponent();

        this._elements.$sections = this._$rootElement.find(config.selectors.sections);
        this._elements.$container = this._$rootElement.find(config.selectors.container);
        this._elements.$wrapper = this._$rootElement.find(config.selectors.wrapper);
        this._elements.$arrowLeft = this._$rootElement.find(config.selectors.arrowLeft), 
        this._elements.$arrowRight = this._$rootElement.find(config.selectors.arrowRight), 
        this._lastWindowTop = $(window).scrollTop();

        this._addEventListeners();

        if(this._elements.$sections.width()+30 > $( document).width() || this._elements.$sections.width() > 1300) {
            this._enableArrows();
            this._enabledArrows = true;
        }
    }

    _getDomElements() {
        return {
            $sections: this._$rootElement.find(config.selectors.sections), 
            $section: $(document).find(config.selectors.section),
        };
    }


    _addEventListeners() {
        const _this = this;

        this._elements.$section.each((i, el) => {
            const $el = $(el);
            const sectionName = $el.data(config.dataAttributes.sectionName);

            $el.attr('id', sectionName);
        });

        
        this._$rootElement.find(config.selectors.sectionLink).on('click', function() {
            // StickySection.setCanBecomneSticky(false);
            // ParalaxSection.setCanTransform(false);

            

            // $([document.documentElement, document.body]).animate({
            //     scrollTop: $(`[data-${config.dataAttributes.sectionName}='${$(this).data(config.dataAttributes.scrollToSectionName)}']`).offset().top
            // }, 2000);

            // setTimeout(() => {
            //     StickySection.setCanBecomneSticky(true);
            //     ParalaxSection.setCanTransform(true);
            // }, 2000);
        });

        _this._elements.$arrowLeft.on('click', () => {
            _this._onLeftArrowClick();
        });

        _this._elements.$arrowRight.on('click', () => {
            _this._onRightArrowClick();
        });

        var dwidth = $(window).width();

        $(window).on('resize', () => {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                this._disableArrows(); 
                this._enabledArrows = false;

                return;
            }

            var wwidth = $(window).width();
            if(dwidth !== wwidth) {
                this._lastWindowTop = $(window).scrollTop();
                if(this._elements.$sections.width()+30 > $( document).width()) {
                    if( !this._enabledArrows){ 
                        this._enableArrows();  
                        this._enabledArrows = true;
                    } else {
                        this._onLeftArrowClick();
                        this._enabledArrows = true;
                    }
                } else {
                    if( this._enabledArrows){
                        this._disableArrows(); 
                        this._enabledArrows = false;
                    }
                }
            }
        });
    }

    _renderComponent() {
        let buttonLabel 
        if($(this._elements.$section[0]).data('anchor-button-label')) {
            buttonLabel = $(this._elements.$section[0]).data('anchor-button-label').split(/,/)
        }
        
        this._$rootElement.html(this._createHtml(buttonLabel))
   
        for (let index = 0; index < this._elements.$section.length; index++) {
            const element = this._elements.$section[index];
         
            if(!index==0){
                $(element).removeAttr('data-anchor-button-label')
            }
            
        }
    }

    _createItemHtml() {
        let html = '';

        this._elements.$section.each((i, el) => {
            const $el = $(el);
            const sectionName = $el.data(config.dataAttributes.sectionName);

            html += `
                <li class="anchor-section-bar__section" tabindex="0" data-anchor-scroll-to-section-name="${sectionName}" data-hover="true">
                    <a class="anchor-section-bar__section-inner" href="#${sectionName}">
                        ${sectionName}
                    </a>
                </li>
            `;  
        });

        return html;
    }

    _createHtml(buttonLabel) {
        let result = ``;
        result += ` <div class="anchor-section-bar__container">
                <div class="anchor-section-bar__wrapper-outer">`
                if(buttonLabel === undefined) {
                    result += `
                     <button aria-label="" class="anchor-section-bar__arrow-left"><span class="path1"></span><span class="path2"></span></button>
                    <button aria-label="" class="anchor-section-bar__arrow-right"><span class="path1"></span><span class="path2"></span></button>`
                }else {
                    result += `
                    <button aria-label="${buttonLabel[0]}" class="anchor-section-bar__arrow-left"><span class="path1"></span><span class="path2"></span></button>
                    <button aria-label="${buttonLabel[1]}" class="anchor-section-bar__arrow-right"><span class="path1"></span><span class="path2"></span></button>`
                }
                result += `
                 <div class="anchor-section-bar__wrapper">
                        <ul class="anchor-section-bar__sections">
                            ${this._createItemHtml()}
                        </ul>
                    </div>
                </div>
            </div>`
        return result;
    }

    _enableArrows() {
        let left = $(document).width() - 30;

        if(left > 1270) {
            left = 1270;
        }

        this._currentTranslateX = this._elements.$sections.width() - left;

        this._elements.$arrowLeft.removeClass(config.classNames.arrowLeftVisible);
        this._elements.$arrowRight.addClass(config.classNames.arrowRightVisible);
        this._elements.$wrapper.addClass(config.classNames.wrapperRight);
        this._elements.$wrapper.css("transform", "translate("+ ((this._currentTranslateX)) +"px)");
    }

    _disableArrows() {
        this._currentTranslateX = 0;
        this._elements.$arrowLeft.removeClass(config.classNames.arrowLeftVisible);
        this._elements.$arrowRight.removeClass(config.classNames.arrowRightVisible);
        this._elements.$wrapper.removeClass(config.classNames.wrapperRight);
        this._elements.$wrapper.css("transform", "translate(0px)");
    }

    _onLeftArrowClick() {
        

        let left = $(document).width() - 30;

        if(left > 1270) {
            left = 1270;
        }

        this._currentTranslateX += $(document).width() / 2 - 30;

        const max = this._elements.$sections.width() - left;

        if(this._currentTranslateX > max) {
            this._currentTranslateX = max;
        }

        
        this._elements.$wrapper.css("transform", "translate("+ ((this._currentTranslateX)) +"px)");
        this._updateArrows();
    }

    _onRightArrowClick() {
        let left = $(document).width() + 30;

        if(left > 1270) {
            left = 1270;
        }

        const max = this._elements.$sections.width() - left;

        if(this._elements.$sections.width() > $(document).width() * 2) {
            this._currentTranslateX -= $(document).width() / 2 + 30;

            if(this._currentTranslateX < 0) {
                this._currentTranslateX = 0;
            }
        } else {
            this._currentTranslateX -= $(document).width() / 2 + 30;

            if(this._currentTranslateX < 0) {
                this._currentTranslateX = 0;
            }
        }

        this._elements.$wrapper.css("transform", `translate(${this._currentTranslateX}px)`);
        this._updateArrows();
    }

    _updateArrows() {
        let left = $(document).width() - 30;

        if(left > 1270) {
            left = 1270;
        }

        const max = this._elements.$sections.width() - left;

        if(this._currentTranslateX === 0) {
            this._elements.$arrowRight.removeClass(config.classNames.arrowRightVisible);
            this._elements.$arrowLeft.addClass(config.classNames.arrowLeftVisible);
        } else if(this._currentTranslateX === max) {
            this._elements.$arrowRight.addClass(config.classNames.arrowRightVisible);
            this._elements.$arrowLeft.removeClass(config.classNames.arrowLeftVisible);
        } else {
            this._elements.$arrowRight.addClass(config.classNames.arrowRightVisible);
            this._elements.$arrowLeft.addClass(config.classNames.arrowLeftVisible);
        }
    }
    


}

moduleRegistry.registerModule('AnchorSectionBar', AnchorSectionBar);
moduleRegistry.autoApplyModule('AnchorSectionBar', config.selectors.root);
